import React, { forwardRef } from 'react';
import styled from 'styled-components';

type OwnProps = React.SVGProps<SVGSVGElement>;

const VendingSmall = styled.svg`
  fill: none;
  width: 32px;
  height: 32px;
`;

const VendingSmallIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <VendingSmall
    {...props}
    ref={ref}
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_13130_37155)">
      <path
        d="M3.17857 18C2.85064 18 2.53123 18 2.24974 18C1.69746 18 1.25 18.4477 1.25 19V26C1.25 26.5523 1.69762 27 2.2499 27C3.4147 27 5.38959 27 7.03571 27M17.3214 18C17.6999 18 18.0049 18 18.2504 18C18.8026 18 19.25 18.4477 19.25 19V26C19.25 26.5523 18.8023 27 18.25 27H13.4643"
        stroke="#00619E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="4.25"
        y1="27"
        x2="28.25"
        y2="27"
        stroke="#00619E"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="7.25"
        y1="30"
        x2="25.25"
        y2="30"
        stroke="#00619E"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M19.25 22.6875V6.60938L22.9167 3H28.5833L31.25 5.29688V24"
        stroke="#00619E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.25 4V23H28.25"
        stroke="#00619E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.25 18L28.25 18"
        stroke="#00619E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.25 13L28.25 13"
        stroke="#00619E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.25 8L28.25 8"
        stroke="#00619E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2417 21.0287C10.7036 20.3137 11.2828 19.3824 11.8596 18.3637C12.4991 17.2343 13.1164 16.0312 13.5685 14.9166C14.04 13.7544 14.25 12.8828 14.25 12.3529C14.25 9.84446 12.3603 8.00707 10.2621 8.00002C8.16155 8.03248 6.28293 9.86284 6.25002 12.3628C6.25261 12.8941 6.46321 13.7644 6.93209 14.9231C7.38452 16.0412 8.0021 17.2485 8.64179 18.3821C9.2111 19.3909 9.78274 20.3147 10.2417 21.0287ZM9.55 23.5976C9.72065 23.8286 9.97411 23.9743 10.25 24C10.5333 23.9748 10.7907 23.8152 10.95 23.5659C10.95 23.5659 16.25 16.0588 16.25 12.3529C16.25 8.84431 13.5637 6 10.25 6C6.95208 6.04004 4.28782 8.86103 4.25 12.3529C4.25 16.0588 9.55 23.5976 9.55 23.5976ZM10.25 13C10.8023 13 11.25 12.5523 11.25 12C11.25 11.4477 10.8023 11 10.25 11C9.69772 11 9.25 11.4477 9.25 12C9.25 12.5523 9.69772 13 10.25 13ZM10.25 15C11.9069 15 13.25 13.6569 13.25 12C13.25 10.3431 11.9069 9 10.25 9C8.59315 9 7.25 10.3431 7.25 12C7.25 13.6569 8.59315 15 10.25 15Z"
        fill="#00AED9"
      />
    </g>
    <defs>
      <clipPath id="clip0_13130_37155">
        <rect width="32" height="32" fill="white" transform="translate(0.25)" />
      </clipPath>
    </defs>
  </VendingSmall>
));

export default VendingSmallIcon;
